module.exports = __webpack_public_path__ + "img/right.d6506e7d.png";